import { getRequest } from '../utils'

export const getCustomerFiles: RequestTypeVariable = {
  getKey: (kind?: string) => ['getCustomerFiles', kind],
  request: async (kind?: string): Promise<CustomerFilesResult> => {
    const { data } = await getRequest<CustomerFilesResult>({
      url: '/customer-files',
      params: kind ? { kind } : undefined,
    })

    return data as CustomerFilesResult
  },
}
